import { compMap, tplMap } from 'BuildArtifacts/templateMaps';

import processedWidgets, {
  mainConfig as componentlessConfig,
} from 'Models/uiConfig/componentlessWidgetsConfig';
import type { AnyWidget } from 'Templates/widgets';

const resultWidgets: AnyWidget[] = [];

for (const componentless of processedWidgets) {
  const complete = {
    ...componentless,
    component: compMap[componentless.type],
  };

  if ('template' in complete && typeof complete.template === 'string') {
    complete.template = tplMap[complete.template];
  }

  resultWidgets.push(complete as AnyWidget);
}

export const mainConfig = {
  ...componentlessConfig,
  Widgets: resultWidgets,
};

export default resultWidgets;
